import vueLib from 'vue';

export default vueLib || window.Vue;
